import { generate } from "shortid";
import { PAGE_THEMES } from "../types";

export const THERAPIST_CLIENT_PAYMENT_PAGES = {
  therapist_client_payment__page: {
    id: `therapist_client_payment__page-${generate()}`,
    type: "therapist_client_payment_type",
    backwards_navigation_enabled: false,
    title: null,
    module_name: null,
    target_state: null,
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: null,
      image: null,
      default_progression: "web_payment_success_page",
      options: [],
    },
  },
};
